import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.offcanvas = new bootstrap.Offcanvas(this.element)
    this.offcanvas.show()
    this.element.addEventListener("hidden.bs.offcanvas", this.handleHidden)
    this.changed = false
    this.closeAfterSave = false
    document.addEventListener("htmx:afterSwap", this.trackChanges)
  }

  disconnect() {
    document.removeEventListener("htmx:afterSwap", this.trackChanges)
    this.offcanvas?.dispose()
  }

  // Called by Save & Close button — flags the controller to dismiss after the HTMX swap
  saveAndClose() {
    this.closeAfterSave = true
  }

  handleHidden = () => {
    if (this.changed) {
      window.location.reload()
    } else {
      this.element.remove()
    }
  }

  trackChanges = (event) => {
    const panelBody = document.getElementById("grid-panel-body")
    if (panelBody && event.detail.target === panelBody) {
      this.changed = true
      if (this.closeAfterSave) {
        this.offcanvas?.hide()
      }
    }
  }
}
